import { apiClient } from './client';

export interface Stats {
  name: string;
  joinedAt: string;
  total: number;
  wins: number;
  winrate: number;
  wagered: string;
  won: string;
  net: string;
  biggestWin: string;
  biggestGame: string | null;
  referrals: number;
}

export const statsApi = {
  me: () => apiClient.get<Stats>('/stats/me').then((r) => r.data),
  byUsername: (u: string) =>
    apiClient.get<Stats>(`/stats/user/${encodeURIComponent(u.replace(/^@/, ''))}`).then((r) => r.data),
};
